import { Component, OnDestroy, OnInit } from '@angular/core';
import { DidDataRetrievalService, t_DataIdentifier, t_DataPoint, t_DataPointTimeSeries } from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BasicMachineFunctionsService, t_dataName, t_FunctionConfig } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { DidConfigService } from 'src/app/services/apiHandler/did-config/did-config.service';
import { dataIdentifierEqual } from 'src/app/services/helper/did-handling-helper';
import { t_OutputCheckedElement } from '../../basicFunctionsViews/basic-machine-function-view/basic-view-table/basic-view-table.component';
import { MatTableDataSource } from '@angular/material/table';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';

@Component({
    selector: 'app-data-display',
    templateUrl: './data-display.component.html',
    styleUrls: ['./data-display.component.scss'],
})
export class DataDisplayComponent implements OnInit, OnDestroy {

    public funcName!: string;
    public functionConfig?: t_FunctionConfig;
    public functionIndex?: number;
    public functionConfigLoaded: boolean;
    private dataIdentifierList: t_DataIdentifier[] = [];
    public graphDataIdentifierToDisplay: t_DataIdentifier[] = [];
    public rawDataSet: t_DataPointTimeSeries[] = [];
    public querySubscription: Subscription = new Subscription();
    public dataSet: MatTableDataSource<t_DataPoint> = new MatTableDataSource<t_DataPoint>();
    public started: boolean = false;
    public locked: boolean = false;


    constructor(private route: ActivatedRoute,
        public apiConnection: BasicMachineFunctionsService,
        public didConfigConnection: DidConfigService,
        private apiDataConnection: DidDataRetrievalService,
        public gatewayConnectionService: GatewayConnectionService,
        private global: GlobalService) {
            this.functionConfigLoaded = false;
            this.global.savedParameters.subscribe({
                next: newValue => {this.locked = newValue.locked;}
            });
        }


    ngOnInit(): void {
        this.createFunctionConfig();
        this.setupDataIdentifierList();
        this.apiDataConnection.initService();
        this.querySubscription = this.apiDataConnection.queryLiveObs.subscribe((queryLiveStatus) => {
            this.loadDataValues();
        });
    }

    ngOnDestroy(): void {
        this.locked = true;
        if(this.locked) {
            this.global.savedParameters.next({locked: this.locked, parameters: this.dataIdentifierList});
        }
        this.querySubscription.unsubscribe();
        /*this.dataIdentifierList.forEach(data => {
            this.didConfigConnection.removeDidFromQueryList({ecu_id: data.ecu_id, data_id: data.data_id}).subscribe();
        });*/
        this.apiDataConnection.stopSendQueryAliveState();
        this.apiDataConnection.stopDataQuery();
        this.apiDataConnection.cleanDataPoints();
        this.apiConnection.removeGeneralMappingFromBasicConfig();
    }

    private createFunctionConfig(){
        this.didConfigConnection.getDidQueryList().subscribe((res) => {
            let dataIdentifiers: t_DataIdentifier[] = JSON.parse(JSON.stringify(res.body));
            this.dataIdentifierList = dataIdentifiers;
            let dataNames: t_dataName[] = [];
            dataIdentifiers.forEach((element: t_DataIdentifier) => {
                let info = this.didConfigConnection.getDidInformation(element);
                let name = info?.did_name;
                dataNames.push({name: name!, identifier: element, didInformation: info, checked: false}); 
            });
            this.funcName = "AllValues"
            
            this.functionConfig = {
                name: this.funcName,
                dataNames: dataNames,
                identifierLoaded: false
            };   
        });

        this.apiConnection.setDataIdentifiersOfFunction("AllValues").then(async () => {
            //console.log("set Dataidentifiers of function: allvalues");
        });
        
    }

    public setupDataIdentifierList() {
        this.apiDataConnection.getAllDidsValues().subscribe((response) => {
            if (response.body != null) {
                this.dataSet.data = response.body;  
            }
        });
    }

    public loadDataValues(): void {
        this.apiDataConnection.getDidsDetails(this.dataIdentifierList).subscribe((response) => {
            if (response.body) {
                this.rawDataSet = this.filterNegativeTimestampsFromRawData(response.body);
            }
        });
    }

    public dataSelected(checkedElement: t_OutputCheckedElement) {
        this.apiConnection.setCheckedStatus(this.funcName, checkedElement.identifier, checkedElement.checked);

        if (checkedElement.checked == true) {
            this.addDataPointToGraph(checkedElement.identifier);
        }
        if (checkedElement.checked == false) {
            this.removeDataPointFromGraph(checkedElement.identifier);
        }
    }

    private addDataPointToGraph(identifierToAdd: t_DataIdentifier) {
        let dataPointAlreadyDisplayed = this.graphDataIdentifierToDisplay.find((dataPointIdentifier) => {
            return dataIdentifierEqual(identifierToAdd, dataPointIdentifier);
        });

        if (dataPointAlreadyDisplayed == undefined) {
            this.graphDataIdentifierToDisplay.push(identifierToAdd);
            this.graphDataIdentifierToDisplay = [...this.graphDataIdentifierToDisplay];
        }
    }

    private removeDataPointFromGraph(identifier: t_DataIdentifier) {
        let indexToRemove: number = this.graphDataIdentifierToDisplay.findIndex((dataPoint) => {
            return dataIdentifierEqual(dataPoint, identifier);
        });

        if (indexToRemove !== -1) {
            this.graphDataIdentifierToDisplay.splice(indexToRemove, 1);
            this.graphDataIdentifierToDisplay = [...this.graphDataIdentifierToDisplay];
        }
    }

    public filterNegativeTimestampsFromRawData(rawDataset: t_DataPointTimeSeries[]) {
        rawDataset.forEach((dataPoint) => {
            dataPoint.data = dataPoint.data?.filter((dataValue) => {
                return new Date(dataValue.timestamp).getTime() != -1;
            });
        });
        return rawDataset;
    }

    public queryStarted(started: boolean) {
        this.started = started;
    }

    public toggleLock() {
        this.locked = !this.locked;
        this.global.savedParameters.next({locked: this.locked});
    }
}
